<template>
<div class="stars-line"></div>
</template>

<style lang="scss">
    .stars-line{
        position: relative;
        width: 540px;
        height: 60px;
        margin: 30px auto;
        &:before{
            content: '';
            width: 100%;
            height: 100%;
            background-image: url('~/assets/svgs/ligne-etoiles.svg');
            background-repeat: no-repeat;
            background-position: center center;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            background-size: contain;
        }
    }
</style>